import RemoveSample from 'components/GlobalModals/ProductSamplesModal/Minidrawer/RemoveSample/RemoveSample';

export default RemoveSample;
